import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './styles/tokens.css';
import './styles/app.css';
import './styles/ui.css';
import { ApiError } from './lib/api.js';
import { App } from './App.js';
import { BuildStamp } from './components/BuildStamp.js';

const queryClient: QueryClient = new QueryClient({
  queryCache: new QueryCache({
    // A 401 anywhere means the session ended: re-resolve auth so the login
    // screen appears in place, instead of the old blank-dashboard reload loop.
    onError: (error) => {
      if (error instanceof ApiError && error.status === 401) {
        void queryClient.invalidateQueries({ queryKey: ['auth-status'] });
      }
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {/* Outside App on purpose: it belongs to the build, not to any page or
          auth state, and every branch of App would otherwise have to render it. */}
      <BuildStamp />
    </QueryClientProvider>
  </StrictMode>,
);
